export default "__VITE_ASSET__f399effd__"